import DisclosureMenu from 'accessible-menu/src/disclosureMenu.js';

/**
 * When this function is called, it gets the desktop navigation bar
 * and sets up the accessible dropdown menus.
 */
export default function () {
  // wait for dom content to load after vue has done its thing
  document.addEventListener("DOMContentLoaded", () => {

    // attach accessible menu library component to our navbar
    const menuEl = document.querySelector(".navbar-nav");

    // define custom selectors to handle mix of ul and divs depending on
    // whether menus have single or multiple child items
    const menu = new DisclosureMenu({
      menuElement: menuEl,
      optionalKeySupport: true,
      submenuItemSelector: '.nav-item:has(.nav-child-menu)',
      submenuSelector: '.nav-child-menu',
    });

    /**
     * Event handler for when a dropdown menu is open or closed.
     *
     * @param $event the event being emitted
     * @param menuItem the menu item being toggled
     */
    const onMenuToggle = ($event, menuItem) => {
      // eslint-disable-next-line no-underscore-dangle
      const menuLink = menuItem._dom.link;
      const menu = menuItem._dom.menuItems;

      if ($event.type === 'keyup' && !($event.code === 'Enter' || $event.code === 'Space')) {
        return;
      }

      // assumed markup order is button and then link
      const aLink = menuLink.nextElementSibling;

      if (menuLink.ariaExpanded === 'true') {
        aLink.classList.add('nav-item__link--active');

        document.addEventListener('click', () => {
          if ($event.target !== aLink) {
            aLink.classList.remove('nav-item__link--active');
          }
        })

        // focus on the link if using keyboard navigation
        if ($event.type === 'keyup') {
          aLink.focus();
        }

        return;
      }

      aLink.classList.remove('nav-item__link--active');
    };

    // get the menu items from the menu for adding our additional event handler
    const  { menuItems } = menu.elements;
    [].forEach.call(menuItems, (menuItem) => {
      // eslint-disable-next-line no-underscore-dangle
      const { _submenu, _dom } = menuItem;

      if (_submenu) {
        // for keyboard navigation, handle focus on text link when menu is opened
        _dom.link.addEventListener('keyup', ($event) => setTimeout(() => onMenuToggle($event, menuItem), 0));
        _dom.link.addEventListener('mouseup', ($event) => setTimeout(() => onMenuToggle($event, menuItem), 0));
      }
    });
  });
}

